export default {
  records: {
    loading: '加载中…',
    loadMore: '加载更多',
    empty: '该时段暂无相关领取记录',
    footer: '仅展示近 7 天领取记录',

    filterCategory: '类型',
    filterTime: '时间',

    category: {
      all: '全部',
      promotions: '优惠',
      tasks: '任务',
      vipSalary: 'VIP俸禄',
      rakeback: '实时返水',
      referral: '推荐返佣',
    },

    module: {
      promotions: '优惠活动',
      tasks: '奖励任务',
      vipSalary: 'VIP俸禄',
      rakeback: '实时返水',
    },

    vipType: {
      DAILY: '日俸禄',
      WEEKLY: '周俸禄',
      MONTHLY: '月俸禄',
      UPGRADE: '晋级奖励',
    },

    vipSalaryDefault: '俸禄',
    taskLevel: '{title} · 第{stage}关',
    rakebackTitle: '实时返水 · {name}',
    rakebackDefault: '实时返水',
  },

  rebate: {
    historyTotal: '历史总领',
    rulesLabel: '规则说明',
    claimableLabel: '当前可领返水',
    claimNow: '立即领取 {amount}',
    claimed: '已领取 ✓',
    nextPayout: '⏳ {countdown} 后即将派发',
    claimSucceeded: '已领取返水 {amount}',
    claimPending: '返水领取成功，奖励发放中 {amount}',
    claimFailed: '领取失败，请稍后重试',
    validBet: '有效投注 {amount}',
    currentRate: '当前比例 {rate}%',
    rulesTitle: '返水规则',
    rateDetailTitle: '返水比例详情',
    filterGameType: '游戏类型',
    filterVendor: '厂商',
    baseMatrix: '基础矩阵',
    vipLevel: 'VIP 等级',
    totalDeposit: '累计充值',
    rebateRate: '返水比例',
    loading: '加载中…',
    rateNote: '返水比例随 VIP 等级提升，以上为当前厂商各等级实时返水比例，升级后即时生效。',
    ruleRatioTitle: '返水比例',
    ruleRatio1:
      '按<b>有效投注额</b>实时计算返水，比例随游戏类型与厂商浮动：电子最高 <b>1.0%</b>、捕鱼最高 <b>0.7%</b>、真人最高 <b>0.6%</b>、棋牌最高 <b>0.5%</b>、体育最高 <b>0.38%</b>。',
    ruleRatio2: 'VIP 等级越高，返水比例越高，具体以「实时返水」页各厂商显示的当前比例为准。',
    ruleDistributeTitle: '派发规则',
    ruleDistribute1: '产生有效投注后<b>实时派发 50%</b>，可立即领取。',
    ruleDistribute2: '剩余 50% 每 <b>2 小时派发 12.5%</b>，共 8 次派发完毕。',
    ruleDistribute3: '返水<b>无上限</b>，投注越多返得越多。',
    ruleClaimTitle: '结算与领取',
    ruleClaim1: '有效投注实时累计，每日 00:00{note} 清算上一自然日数据。',
    ruleClaim2: '返水在「奖励中心 · 实时返水」<b>手动领取</b>，未领取的返水将持续累计，不会过期。',
    ruleClaim3: '领取的返水需完成 <b>{n} 倍流水</b>后方可提现。',
    ruleClaimFree: '领取的返水<b>免码</b>，直接进入可用余额。',
    ruleClaim4: '对冲、刷单等无效投注不计返水。',
    all: '全部',
    gameType: {
      original: '综合',
      slots: '电子',
      card: '棋牌',
      live: '真人',
      lottery: '彩票',
      fish: '捕鱼',
      sport: '体育',
      esport: '电竞',
    },
  },

  vip: {
    loading: '加载中...',
    loadError: '加载失败，请稍后重试',
    retry: '重试',
    claimReceived: '{label}{amount} 已入账余额',
    claimProcessing: '{label}{amount} 领取成功，奖励发放中',

    cardType: {
      UPGRADE: '晋级彩金',
      DAILY: '日俸禄',
      WEEKLY: '周俸禄',
      MONTHLY: '月俸禄',
    },

    action: {
      AVAILABLE: '领取',
      /** 已点领取、钱包还没落定；与优惠活动 CLAIM_PROCESSING 同文案 */
      PROCESSING: '发放中',
      CLAIMED: '已领取 ✓',
      EXPIRED: '已过期',
      LOCKED_WITH_DATE: '{date} 可领',
      LOCKED_COUNTDOWN: '{countdown} 后可领',
      LOCKED_NO_DATE: '未开放',
      DISABLED: '不可用',
    },

    hero: {
      currentLevel: '当前等级',
      rules: '规则说明',
      maxLevel: '已达最高等级',
      nextLevel: '距 V{level} 还需充值',
    },

    benefit: {
      title: '📊 等级权益表',
      hint: '共 {total} 级 · 滑动查看',
      level: '等级',
      totalDeposit: '累计充值',
      upgradeBonus: '晋级彩金',
      dailyBonus: '日俸禄',
      weeklyBonus: '周俸禄',
      monthlyBonus: '月俸禄',
    },

    rules: {
      title: 'VIP俸禄规则',
      levelAndUpgradeTitle: '等级与晋级',
      levelAndUpgrade1:
        'VIP 等级依据<b>累计有效充值</b>自动升级，<b>仅看充值金额、无打码要求</b>，达到对应等级门槛即刻升级。',
      levelAndUpgrade2:
        '升级瞬间发放对应等级的<b>晋级彩金</b>，共 <b>50</b> 级，等级越高彩金越丰厚（V18 {amount18} / 最高 V50 {amount50}）。',
      levelAndUpgrade3: '每档只在<b>首次达成</b>时发放一次晋级彩金，跨级升级按最高档一次性发放。',
      retentionTitle: '保级规则',
      retention1:
        '领取日 / 周 / 月俸禄后，需在对应周期内完成<b>领取总额 10 倍</b>以上的有效打码量方可保级。',
      retention2:
        '例：本月累计领取俸禄 {amount1}，需完成 ≥ {amount2} 有效打码量，否则次月下降 1 级。',
      retention3:
        '<b>未领取俸禄的周期不作考核、不会降级</b> —— 不想打码可暂不领取俸禄，等级保持不变。',
      paymentTitle: '俸禄发放',
      payment1: '<b>日俸禄</b>：每日 00:00{note} 刷新，当日手动领取，过期不补。',
      payment2: '<b>周俸禄</b>：每周一 00:00{note} 开放，本周内领取。',
      payment3: '<b>月俸禄</b>：每月 1 号 00:00{note} 开放，本月内领取。',
      payment4: '俸禄金额按当前 VIP 等级发放，升级后次日起按新等级计发。',
      claimTitle: '领取与提现',
      claim1: '所有俸禄与彩金均在「奖励中心 · VIP俸禄」手动领取，系统不自动发放。',
      claim2: '领取的奖励金需完成 <b>1 倍流水</b>后方可提现。',
      claim3:
        '严禁对冲、套利等违规行为，一经发现将取消 VIP 资格并追回奖励。本活动最终解释权归平台所有。',
    },
  },

  daily: {
    stageLabel: '第{no}关',
    claimAllPartial: '已领取 {amount}，部分关卡仍在处理中',
    claimAll: '已一键领取 {amount}',
    claimLevelClaimed: '已领取 {amount}',
    claimLevelProcessing: '领取处理中 {amount}',
    claimLevelChallenge: '请完成验证',
    claimLevelPending: '领取结果待确认',
    bannerLabel: '今日可领任务奖励',
    claimAllButton: '一键领取',
    claimedOutButton: '今日已领完',
    currentDeposit: '当前充值',
    currentCount: '当前进度',
    currentBet: '当前有效投注',
    nextStage: '下一关',
    completed: '已完成',
    requirementDeposit: '充值',
    requirementCount: '目标',
    requirementBet: '投注',
    typeBetTurnover: '打码量',
    typeBetCount: '投注局数',
    typeDeposit: '充值额',
    typeLogin: '登录天数',
    typePlayGame: '试玩游戏',
    unitRound: '局',
    unitDay: '天',
    currentOf: '当前{name}',
    statusClaimed: '✓ 已领',
    statusClaimable: '可领取',
    statusProgress: '进行中',
    statusLocked: '未解锁',
    claimSuccessToast: '领取成功 {amount}',
  },

  acts: {
    loading: '加载中…',
    empty: '暂无活动',
    detailTitle: '活动详情',
    todayAvailable: '今天可参与',
    waitingDays: '距活动 {days} 天',
    waitingBirthday: '距生日 {days} 天',
    remainingDays: '还需 {days} 天',
    achievedDays: '已连续 {days} 天',
    claimSuccess: '领取成功',
    claimProcessing: '发放中，请稍后查看',
    claimFailed: '领取失败，请稍后再试',
    unsupportedResource: '暂不支持跳转',
    birthdayTitle: '设置生日',
    birthdayHint: '生日设置成功后不可修改，请确认无误后再提交。',
    birthdayConfirm: '确认设置',
    birthdaySet: '生日设置成功',
    status: {
      UNSET: '未设置',
      INCOMPLETE: '未完成',
      WAITING: '等待中',
      IN_PROGRESS: '进行中',
      CLAIMABLE: '可领取',
      CLAIM_PROCESSING: '发放中',
      CLAIMED: '已领取',
      EXPIRED: '已过期',
    },
    action: {
      UNSET: '确认设置',
      DEPOSIT: '去充值',
      WITHDRAW: '去提现',
      GAME: '去游戏',
      SET_BIRTHDAY: '确认设置',
      CLAIM: '立即领取',
      OPEN_RESOURCE: '立即前往',
      AUTO: '系统自动发放中',
      NONE: '暂无',
    },
    detail: {
      secDetail: '活动详情',
      secRules: '活动细则',
      listSep: '、',
      clauseSep: '；',
      rowDesc: '活动描述',
      rowTrigger: '触发时机',
      rowRequire: '资格要求',
      rowChannel: '钱包类型',
      rowCurrency: '币种范围',
      rowDepositReq: '充值要求',
      rowSchedule: '活动时间',
      rowCalc: '计算方式',
      rowScope: '游戏范围',
      rowThreshold: '最低门槛',
      rowStreakWeek: '周连续',
      rowStreakMonth: '月连续',
      rowStreakWeekPrize: '周奖励',
      rowStreakMonthPrize: '月奖励',
      rowMethod: '奖励方式',
      rowAmount: '奖励金额',
      rowCap: '奖励上限',
      rowClaimWay: '领取方式',
      rowValidity: '领取时效',
      rowCount: '领取次数',
      rowWager: '流水要求',
      rowRewardRange: '奖励范围',
      rowNote: '特殊说明',
      viaType: '通过【{type}】',
      channelTypesEtc: '{types} 等',
      reqAmount: '，单笔金额不低于 {amount}，',
      reqWithdraw: '，单笔提现不低于 {amount}，',
      weeklyPrefix: '每{days}',
      monthlyPrefix: '每月 {days}',
      dayOfMonth: '{d} 号',
      weekday: {
        1: '周一',
        2: '周二',
        3: '周三',
        4: '周四',
        5: '周五',
        6: '周六',
        7: '周日',
      },
      hlReward: '奖励 {amount}',
      hlRewardTop: '奖励 最高 {amount}',
      methodFixed: '固定金额',
      methodRatePlain: '按{base}比例计算（{rate}）',
      methodTiered: '按达标档位发放',
      methodTracks: '阶梯式固定金额',
      methodVip: '根据王者等级发放固定金额',
      baseDeposit: '充值金额',
      baseWithdraw: '提现金额',
      baseLoss: '亏损金额',
      baseBet: '投注金额',
      baseWin: '中奖金额',
      basePayout: '派彩金额',
      baseReturn: '回归充值金额',
      baseTicket: '注单金额',
      baseMultiplier: '中奖倍数',
      capTop: '最高 {amount}',
      capTopDaily: '最高 {amount}/天',
      minDeposit: '最低充值 {amount}',
      reqChannelType: '使用{type}充值',
      reqChannelTypeMin: '使用{type}充值，最低充值 {amount}',
      unitYuan: '元',
      tierRow: '达到 {threshold}：{value}',
      tierRandom: '随机 {min} ~ {max}',
      vipRange: '礼金按 VIP 等级发放（{min} ~ {max}）',
      rewardVipTable: '礼金按 VIP 等级发放',
      targetAvailable: '奖励发放至可用余额',
      targetBonus: '奖励发放至彩金余额，完成流水要求后方可提现',
      wagering: '{n} 倍流水可提现',
      ruleTarget: '参与对象：{v}',
      ruleClaimManual: '奖励需在「奖励中心」手动领取，系统不自动发放。',
      ruleClaimAuto: '达标后系统自动发放奖励。',
      ruleValidity: '领取时效：{v}。',
      ruleWager: '奖励金需完成 {n} 倍流水可提现后方可提现。',
      ruleDisclaimer: '本活动最终解释权归平台所有，严禁违规套利，一经发现将取消资格并追回奖励。',
      claimManual: '奖励中心手动领取',
      claimAuto: '达标自动发放',
      validityDeposit: '充值后 {d} 天内领取，过期失效',
      validityWithdraw: '提现后 {d} 天内领取，过期失效',
      validityDays: '满足条件后 {d} 天内领取，过期失效',
      validityHours: '获得资格后 {h} 小时内领取，过期失效',
      limitLifetime: '终身 {n} 次',
      limitPerWallet: '每种钱包 {n} 次',
      limitDaily: '每日 {n} 次',
      limitDailyPerDay: '每个活动日 {n} 次',
      limitMemberDay: '每个会员日 {n} 次',
      limitYearly: '每年 {n} 次',
      limitStreakBoth: '周/月各 1 次',
      limitStreakWeekly: '每周 1 次',
      limitStreakMonthly: '每月 1 次',
      streakCondDays: '连续 {n} 天每天充值',
      streakCondAny: '每天都有充值',
      streakCondGe: ' ≥ {amount}',
      streakWeekRow: '上周{cond}，本周一可领',
      streakMonthRow: '上月{cond}，本月 1 号可领',
      scopeGames: '适用游戏：{names}',
      scopeCategories: '游戏类型：{names}',
      scopeVendors: '游戏厂商：{names}',
      scopeAll: '全部游戏均可参与',
      scopeAllCat: '全部{name}',
      scopeConfigurable: '（可配置指定游戏）',
      amountRange: '{min} - {max}',
      noteBirthday: '需先采集用户生日日期，生日设置后不可修改',
      validityBirthday: '生日当天 {h} 小时内',
      thresholdMult: '{metric} ≥ {v} 倍',
      thresholdAmtGe: '{metric} ≥ {amount}',
      rule: {
        trigDepositSeq: '用户完成第 {n} 笔充值时',
        trigFirstWithdraw: '用户完成首次成功提现时',
        trigRegMilestone: '注册满 {days} 天后',
        trigChannelFirst: '首次使用指定钱包完成充值时',
        trigChannelNamed: '首次使用{type}完成充值时',
        trigDaily: '用户当日完成第 1 笔充值时',
        trigDate: '指定日期完成充值时',
        trigDateOn: '{days}完成充值时',
        trigBet: '{metric}达标后',
        trigBetExtreme: '今日可领取（基于昨日数据）',
        trigLossRescue: '今日可领取（基于昨日数据）',
        trigLoss: '昨日净亏损达标后',
        trigStreak: '上一自然周期内每日连存达标后',
        trigBirthday: '生日当天',
        trigComeback: '符合条件的用户完成回归后首笔充值时',
        reqDepositFirst: '新注册用户，历史充值次数 = 0',
        reqDepositSecond: '已完成首存，历史充值次数 = 1',
        reqDepositThird: '已完成二存，历史充值次数 = 2',
        reqDepositNth: '已完成第 {c} 笔充值，历史充值次数 = {c}',
        reqMinDeposit: '，单笔充值不低于 {amount}',
        reqMinWithdraw: '，单笔提现不低于 {amount}',
        reqFirstWithdraw: '注册 {days} 天内、历史提现次数 = 0',
        reqFirstWithdrawAny: '历史提现次数 = 0',
        reqRegMilestone: '注册满 {days} 天',
        reqRegCum: '，累计充值 ≥ {amount}',
        reqChannelFirst: '该钱包渠道历史充值次数 = 0',
        reqLossRescue: '昨日净亏损 ≥ {amount}',
        reqLossRescueAny: '昨日净亏损',
        reqLossRescueScoped: '昨日{scope}净亏损 ≥ {amount}',
        reqLossRescueScopedAny: '昨日{scope}净亏损',
        reqChannelNamed: '{type}渠道历史充值次数 = 0',
        reqDailyDeposit: '当日尚未充值（每日 0 点重置）',
        reqBirthdayVip: '已设置出生日期，王者等级 ≥ {level} 级',
        reqBirthdayAny: '已设置出生日期',
        reqComebackAmt: '历史总存款 ≥{amount}',
        reqComebackCount: '历史充值 ≥{n} 次',
        reqComebackNoDep: '最近 {days} 天无存款',
        reqComebackNoGame: '最近 {days} 天无游戏',
        reqComebackAny: '回归用户',
        birthdayNote: '需先采集用户生日日期，生日设置后不可修改。',
        depositSeq: '第 {n} 笔成功充值{req}可获得对应奖励。',
        depositSeqNote: '指定笔次未达到门槛时，后续充值不会补算为该笔。',
        depositSeqBase: '比例奖励以第 {n} 笔充值金额为基数计算。',
        withinDays: '注册后 {days} 天内，',
        firstWithdraw: '{within}首次成功提现{req}可获得对应奖励。',
        firstWithdrawNote: '首次提现未达到门槛时，后续提现不会补算为首次。',
        firstWithdrawBase: '比例奖励以首次提现金额为基数计算。',
        andCumDeposit: '，且累计充值达到 {amount}，',
        regMilestone: '注册满 {days} 天{cum}可获得对应奖励。',
        regMilestoneTier: '分档奖励按达标时的历史累计充值金额选档，各档奖励不累加。',
        channelFirst: '首次通过【{type}】成功充值{req}可获得对应奖励。',
        channelFirstNote: '同一充值类型下的不同钱包或渠道不会分别计算首充。',
        dailyDeposit: '每日第一笔成功充值{req}可获得对应奖励，按站点自然日统计。',
        dailyDepositNote: '当天首笔未达到门槛时，后续充值不补作当天首充。',
        dailyDepositBase: '比例奖励以当天首笔充值金额为基数计算。',
        dateDeposit: '在{days}{type}成功充值{req}可获得对应奖励。',
        dateDepositNote: '每个活动日独立计算资格，同一活动日多笔充值不叠加奖励。',
        dateDepositBase: '比例奖励以触发资格的单笔充值金额为基数计算。',
        metric: {
          BET_AMOUNT: '昨日单笔最大投注金额',
          WIN_AMOUNT: '昨日单笔最大派彩金额',
          MULTIPLIER: '昨日单笔最高中奖倍数',
        },
        thresholdX: '达到 {v} 倍，',
        thresholdAmt: '达到 {amount}，',
        metricShort: {
          BET_AMOUNT: '昨日单笔投注金额',
          WIN_AMOUNT: '昨日单笔中奖金额',
          MULTIPLIER: '昨日中奖倍数',
        },
        calcBetExtreme: '取{metric}最高的那笔',
        betExtreme: '{metric}{th}可获得对应奖励。',
        betExtremeNote: '统计昨日已结算注单中的单笔极值，日结完成后产生领取资格。',
        lossRescue: '昨日在适用范围内净亏损{th}可获得救援奖励。',
        lossRescueNote: '净亏损按盈亏抵扣计算，日结完成后产生领取资格。',
        streakDaily: '每天累计充值不少于 {amount}',
        streakDailyAny: '每天有成功充值',
        streakPrize: '，可获得 {amount}',
        streakWeekly:
          '周档：上一自然周（周一至周日）{daily}{prize}。本周一开始结算，符合条件后可在本周内领取，每期一次。',
        streakMonthly:
          '月档：上一自然月{daily}{prize}。月份天数按实际日历计算，本月 1 日开始结算，符合条件后可在本月内领取，每期一次。',
        birthdayVip: 'VIP {level} 及以上会员',
        birthday: '{vip}生日当天满足条件后可获得生日礼金。',
        birthdaySet: '出生日期在「我的 → 个人资料」设置，设置后不可修改。',
        silenceDeposit: '连续 {days} 天未充值',
        silenceGame: '连续 {days} 天未游戏',
        lifeDepositAmt: '历史累计充值达到 {amount}',
        lifeDepositCount: '历史成功充值满 {n} 笔',
        comeback: '回归条件：{conds}；以上条件需同时满足，历史条件不含本次回归充值。',
        comebackGeneric: '满足回归条件后可获得对应奖励。',
        comebackDeposit: '本次回归充值不低于 {amount} 时触发奖励。',
        comebackBase: '比例奖励以本次回归充值金额为基数计算。',
      },
    },
  },
}
